"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _balanceBatchSend = require("@/api/balanceBatchSend");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var validateFile = function validateFile(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error('请上传文件'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible1: false,
      ruleForm: {
        fileList: [],
        remark: ''
      },
      rules: {
        fileList: [{
          required: true,
          message: '请上传文件',
          validator: validateFile,
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(data) {
      this.dialogVisible1 = true;
      console.log(data);
    },
    onClose: function onClose() {
      this.ruleForm.remark = '';
      this.ruleForm.fileList = [];
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible1 = false;
    },
    handleRemove: function handleRemove() {
      this.ruleForm.fileList = [];
    },
    change: function change(file, fileList) {
      this.ruleForm.fileList = fileList;
      this.$refs.ruleForm.validateField('fileList');
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var obj = new FormData();
          obj.append('file', _this.ruleForm.fileList[0].raw);
          obj.append('remark', _this.ruleForm.remark);
          (0, _balanceBatchSend.importExe)(obj).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.onClose();
              _this.$emit('refresh');
            } else {
              _this.$message.error('导入失败！');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};